export default __webpack_public_path__ + "static/media/amazon.1529de67.jpg";